export { default as claimantRelationship } from './claimantRelationship';
